module.exports = __webpack_public_path__ + "static/media/lukas.1bc47052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/lukas.png
// module id = 1486
// module chunks = 0